import { MemberVbAccountEstimatedAnnualPaymentTotal } from './member-vb-account-estimated-annual-payment-total';

export class MpMemberVbAccountEstimatedAnnualPaymentTotal extends MemberVbAccountEstimatedAnnualPaymentTotal {
  public isBelowAnnualMinimum: boolean = false;
}
